import React from "react";
import {
  MagnifyingGlassIcon,
  IdentificationBadgeIcon,
  VideoCameraIcon,
} from "@phosphor-icons/react";

const STEPS = [
  {
    number: "01",
    icon: MagnifyingGlassIcon,
    title: "Browse live shows",
    body: "Tap into auctions running right now. Filter by category — Pokemon, Sneakers, Rolex, Luxury — and peek in without signing up.",
    accent: "bg-[#1D78AB]",
  },
  {
    number: "02",
    icon: IdentificationBadgeIcon,
    title: "Verify once, buy forever",
    body: "Upload a US photo ID one time. Every buyer and seller on Bidorah is a verified human — no bots, no shill bidders, no scams.",
    accent: "bg-amber-500",
  },
  {
    number: "03",
    icon: VideoCameraIcon,
    title: "Bid, buy, or go live",
    body: "Place real-time bids or hit Buy. Want to sell? Apply for a Founder seat and start broadcasting to thousands within a week.",
    accent: "bg-emerald-500",
  },
];

export default function HowItWorks() {
  return (
    <section
      className="border-b border-zinc-200 bg-white"
      data-testid="home-how-it-works"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold text-[#1D78AB] mb-3">
            How Bidorah works
          </p>
          <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter">
            From browsing to bidding in three clean steps.
          </h2>
          <p className="text-zinc-600 mt-4 max-w-xl">
            We took everything buyers hate about live auctions — shill bids,
            anonymous sellers, surprise fees — and killed it at the protocol
            level.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {STEPS.map((s) => (
            <div
              key={s.number}
              className="relative rounded-3xl border border-zinc-200 bg-white p-7 hover:border-zinc-300 transition"
              data-testid={`how-step-${s.number}`}
            >
              <div
                className={`inline-flex items-center justify-center h-11 w-11 rounded-2xl text-white ${s.accent}`}
              >
                <s.icon size={20} weight="fill" />
              </div>
              <div className="absolute top-6 right-6 font-display font-black text-4xl text-zinc-100 leading-none">
                {s.number}
              </div>
              <h3 className="font-display font-black text-xl tracking-tight mt-4">
                {s.title}
              </h3>
              <p className="text-sm text-zinc-600 mt-2 leading-relaxed">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
